import React, { Component } from "react"
import "./WelcomeModal.css"
import { getTranslation } from "../../assets/creator/translations"

class WelcomeModal extends Component {
	handleEditPreviousTemplateBtn = () => {
		this.props.handleIsEditedTemplate(true);
		this.props.handleIsShowWelcomeModal(false);
		this.props.handleIsShowChooseModelModal(true);
	}
	
	handleEditPredefinedTemplateBtn = () => {
		this.props.handleIsShowWelcomeModal(false);
		this.props.handleIsShowChooseModelModal(true);
	}

	render() {
		return (
			!this.props.show ? null : (
				<div className='welcome-modal'>
					<section className='welcome-modal__main '>
						<div className='welcome consecutiveVisit'>
							<div className='welcome-modal__title'>
								{getTranslation("Msg_WelcomeAgain")}
							</div>
		
							<div className='welcome-modal__text'>
								<p>{getTranslation("Msg_WeSavedYourProject")}</p>
								<p>{getTranslation("Msg_ContinueOrMakeNewProject")}</p>
							</div>
		
							<div className='welcome-modal__btn-group'>
								<p className='welcome-modal__link continueEditProjectBtn' onClick={this.handleEditPreviousTemplateBtn}>
									{getTranslation("Btn_EditPreviousTemplate")}
								</p>
								<button
									className='welcome-modal__btn welcome-modal__btn--active createNewProjectBtn'
									onClick={this.handleEditPredefinedTemplateBtn}>
									{getTranslation("Btn_EditPredefinedTemplate")}
								</button>
							</div>
							<span className="border-line"></span>
						</div>
					</section>
				</div>
			)
		)
	}
	
}

export default WelcomeModal



// WEBPACK FOOTER //
// ./src/components/WelcomeModal/WelcomeModal.js